import styled from 'styled-components';

export const Container = styled.div`
  max-width: 100%;
  height: 80vh;
`;
